import AdminMfaChallenge from "./AdminMfaChallenge";

type Props = {
    busy: boolean;
    error: string | null;
    mfaRequired: boolean;
    onGoogle: () => void;
    onVerifyMfa: (code: string) => Promise<void>;
};

export default function AdminLoginControls(props: Props) {
    return <>
        {props.error && <div className="mb-5 rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700">
            {props.error}
        </div>}
        {props.mfaRequired && <AdminMfaChallenge busy={props.busy} onVerify={props.onVerifyMfa} />}
        {!props.mfaRequired && <>
            <button onClick={props.onGoogle} disabled={props.busy} className="flex w-full items-center justify-center gap-3 rounded-xl bg-[#0b2f75] px-4 py-3.5 font-bold text-white shadow-lg shadow-blue-900/20 transition hover:-translate-y-0.5 hover:bg-blue-800 disabled:translate-y-0 disabled:opacity-50">
                <span className="grid h-6 w-6 place-items-center rounded-full bg-white text-sm font-black text-blue-700">G</span>{props.busy ? "Signing in…" : "Continue with Google"}
            </button>
            <p className="mt-4 text-center text-xs leading-5 text-slate-500">Administrator access is Google-only and requires an approval from a trusted operator.</p>
        </>}
    </>;
}
